import { Trophy, Award, Star } from "lucide-react";

const gradeColor = (g) => {
  if (!g) return "#71717a";
  if (g.startsWith("A")) return "#34d399";
  if (g.startsWith("B")) return "#60a5fa";
  if (g.startsWith("C")) return "#fbbf24";
  return "#f87171";
};

export default function Leaderboard({ data }) {
  const getRankBadge = (r) => r === 1 ? "gold" : r === 2 ? "silver" : r === 3 ? "bronze" : "default";
  const getRankClass = (r) => !r ? "" : r <= 3 ? "top" : r <= 10 ? "good" : "";

  return (
    <div className="leaderboard-section" data-testid="leaderboard-section">
      <h2 className="section-title"><Trophy size={18} color="#fbbf24" /> Marketer Leaderboard</h2>
      {data.length === 0 ? (
        <div className="empty-state"><Award size={48} /><div className="empty-text">No data yet</div></div>
      ) : (
        <div className="leaderboard-container">
          <table className="leaderboard-table">
            <thead>
              <tr>
                <th>Rank</th><th>Marketer</th><th>Entries</th><th>Live</th>
                <th>Deleted</th><th>Dupes</th><th>Dup Rate</th><th>Success Rate</th><th>Avg Grade</th><th>Upvotes</th><th>Avg Rank</th><th>Score</th>
              </tr>
            </thead>
            <tbody>
              {data.map(e => (
                <tr key={e.marketer} data-testid={`leaderboard-row-${e.marketer}`}>
                  <td><div className={`rank-badge ${getRankBadge(e.rank)}`}>{e.rank}</div></td>
                  <td>
                    <span className="marketer-name">
                      {e.rank <= 3 && <Award size={16} color={e.rank===1?'#fbbf24':e.rank===2?'#9ca3af':'#cd7f32'} />}
                      {e.marketer}
                    </span>
                  </td>
                  <td style={{fontFamily:'JetBrains Mono'}}>{e.total}</td>
                  <td style={{color:'var(--live-green)',fontFamily:'JetBrains Mono'}}>{e.live}</td>
                  <td style={{color:'var(--deleted-red)',fontFamily:'JetBrains Mono'}}>{e.deleted}</td>
                  <td style={{fontFamily:'JetBrains Mono', color: e.duplicates > 0 ? '#f97316' : '#52525b'}} title={`${e.duplicates || 0} duplicate URLs`}>{e.duplicates || 0}</td>
                  <td>
                    {e.dup_rate > 0 ? (
                      <span style={{
                        fontFamily: 'JetBrains Mono', fontSize: 12, padding: '1px 6px', borderRadius: 4,
                        background: e.dup_rate > 30 ? '#7f1d1d' : e.dup_rate > 10 ? '#78350f' : 'transparent',
                        color: e.dup_rate > 30 ? '#fca5a5' : e.dup_rate > 10 ? '#fbbf24' : '#71717a',
                      }}>{e.dup_rate}%</span>
                    ) : <span style={{color:'#52525b', fontSize: 12}}>0%</span>}
                  </td>
                  <td>
                    <div className="success-rate">
                      <div className="success-bar"><div className="success-fill" style={{width:`${e.success_rate}%`}}></div></div>
                      <span>{e.success_rate}%</span>
                    </div>
                  </td>
                  <td>
                    {e.avg_grade ? (
                      <span data-testid={`grade-${e.marketer}`} style={{
                        fontFamily: 'JetBrains Mono', fontWeight: 700, fontSize: 13,
                        padding: '2px 8px', borderRadius: 4, display: 'inline-block',
                        background: `${gradeColor(e.avg_grade)}15`,
                        color: gradeColor(e.avg_grade),
                        border: `1px solid ${gradeColor(e.avg_grade)}30`,
                      }} title={`Avg score: ${e.avg_grade_score}/100 (${e.graded_count} graded)`}>
                        {e.avg_grade}
                      </span>
                    ) : <span style={{color:'#52525b', fontSize: 12}}>-</span>}
                  </td>
                  <td style={{fontFamily:'JetBrains Mono'}}>{e.upvotes}</td>
                  <td>{e.avg_rank ? <span className={`rank-number ${getRankClass(e.avg_rank)}`}>#{e.avg_rank}</span> : '-'}</td>
                  <td><span className="score-badge">{e.score}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
